import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  editCompanyLocation,
  UpdateLocationRequest,
} from 'api/company/location'
import { companyLocationsKey } from './keys'

export const useEditCompanyLocationMutation = (
  companyId: number,
  locationId: number
) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: UpdateLocationRequest) =>
      editCompanyLocation(companyId, locationId, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: companyLocationsKey(companyId),
      })
    },
  })
}
